import { render, staticRenderFns } from "./FooterNav.vue?vue&type=template&id=171d0968&scoped=true&"
import script from "./FooterNav.vue?vue&type=script&lang=ts&"
export * from "./FooterNav.vue?vue&type=script&lang=ts&"
import style0 from "./FooterNav.vue?vue&type=style&index=0&id=171d0968&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171d0968",
  null
  
)

export default component.exports